import { RootState } from '@atredux/store'
import { ITool } from '@atredux/slices/toolSlice'

export const getSelectedTool = (state: RootState): ITool => state.tool.tool
export const getLastNonMigratedTool = (state: RootState): ITool => state.tool.lastNonMigratedTool
export const getLastMigratedTool = (state: RootState): ITool => state.tool.lastMigratedTool
export const getOpenModalCalledWithMigratedTool =
    (state: RootState): boolean => state.tool.openModalCalledWithMigratedTool
export const isToolBarHidden = (state: RootState): boolean => state.tool.isToolBarHidden
export const getPreviousTool = (state: RootState): ITool | null => state.tool.previousTool
